































import {Vue, Component, Emit} from 'vue-property-decorator'

@Component
export default class IpGuidePopup extends Vue {
	@Emit('ipGuidePopupToggle')
	private close() {}
}
